/**
 * @generated SignedSource<<fe6af1dafb50a175fda93fc0bee146c0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type issueTable_nativeIssueTable_project$data = {
  readonly " $fragmentSpreads": FragmentRefs<"groupTableBody_nativeIssueTable_project" | "tableBody_nativeIssueTable_project">;
  readonly " $fragmentType": "issueTable_nativeIssueTable_project";
};
export type issueTable_nativeIssueTable_project$key = {
  readonly " $data"?: issueTable_nativeIssueTable_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"issueTable_nativeIssueTable_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "issueTable_nativeIssueTable_project",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "groupTableBody_nativeIssueTable_project"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isConditionalFormattingEnabled",
          "variableName": "isConditionalFormattingEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "tableBody_nativeIssueTable_project"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "38dfe2d12493a4d4072e6d351e4b9c2a";

export default node;
